import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { ScrollToTop } from './components/ScrollToTop';
// Pages
import { Home } from './pages/Home';
import { About } from './pages/About';
import { Programs } from './pages/Programs';
import { LongevityProgram } from './pages/LongevityProgram';
import { CorporateWellness } from './pages/CorporateWellness';
import { FaithFitness } from './pages/FaithFitness';
import { Testimonials } from './pages/Testimonials';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
// Insights Pages
import { InsulinResistance } from './pages/insights/InsulinResistance';
import { StrengthLongevity } from './pages/insights/StrengthLongevity';
import { MetabolicReset } from './pages/insights/MetabolicReset';
import { CortisolConnection } from './pages/insights/CortisolConnection';
import { FaithDiscipline } from './pages/insights/FaithDiscipline';
import { FatLossScience } from './pages/insights/FatLossScience';
export function App() {
  return <BrowserRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col bg-dark" data-id="element-2">
        <Navbar data-id="element-3" />
        <div className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<About data-id="element-9" />} data-id="element-8" />
            <Route path="/programs" element={<Programs data-id="element-11" />} data-id="element-10" />
            <Route path="/programs/longevity" element={<LongevityProgram data-id="element-13" />} data-id="element-12" />
            <Route path="/programs/corporate-wellness" element={<CorporateWellness data-id="element-15" />} data-id="element-14" />
            <Route path="/programs/faith-fitness" element={<FaithFitness data-id="element-17" />} data-id="element-16" />
            <Route path="/testimonials" element={<Testimonials data-id="element-19" />} data-id="element-18" />
            <Route path="/blog" element={<Blog data-id="element-21" />} data-id="element-20" />
            <Route path="/contact" element={<Contact data-id="element-23" />} data-id="element-22" />

            {/* Insights Routes */}
            <Route path="/insights/insulin-resistance" element={<InsulinResistance data-id="element-25" />} data-id="element-24" />
            <Route path="/insights/strength-longevity" element={<StrengthLongevity data-id="element-27" />} data-id="element-26" />
            <Route path="/insights/metabolic-reset" element={<MetabolicReset data-id="element-29" />} data-id="element-28" />
            <Route path="/insights/cortisol-connection" element={<CortisolConnection data-id="element-31" />} data-id="element-30" />
            <Route path="/insights/faith-discipline" element={<FaithDiscipline data-id="element-33" />} data-id="element-32" />
            <Route path="/insights/fat-loss-science" element={<FatLossScience data-id="element-35" />} data-id="element-34" />
          </Routes>
        </div>
        <Footer data-id="element-36" />
      </div>
    </BrowserRouter>;
}